import {
  AiFlowNodeColorMap,
  AiFlowNodeIconMap,
  AiFlowNodeLabelMap,
  CODE_GRAPH_ELIGIBLE_CATEGORIES,
} from './constants';
import type { AiFlowNodeCategory } from './types';
import {
  getNodeSelectionOpacity,
  getEdgeSelectionOpacity,
} from '../flow-graph-base/graph.utils';

export const getAiFlowNodeColor = (type: AiFlowNodeCategory) =>
  AiFlowNodeColorMap[type] ?? AiFlowNodeColorMap.AGENT;

export const getAiFlowNodeIcon = (type: AiFlowNodeCategory) =>
  AiFlowNodeIconMap[type] ?? AiFlowNodeIconMap.AGENT;

export const getAiFlowNodeLabel = (type: AiFlowNodeCategory) =>
  AiFlowNodeLabelMap[type] ?? type;

export const isCodeGraphEligible = (type: AiFlowNodeCategory) =>
  CODE_GRAPH_ELIGIBLE_CATEGORIES.has(type);

export const getAiFlowNodeOpacity = (nodeId: string, selectedNodeId?: string) =>
  getNodeSelectionOpacity(nodeId, selectedNodeId, 0.15);

export const getAiFlowEdgeOpacity = (
  source: string,
  target: string,
  selectedNodeId?: string,
) => getEdgeSelectionOpacity(source, target, selectedNodeId, 0.15);
